import { errorLogger as logError } from './ErrorHandler'

export type LoggerGlobalState = {
  AccountData?: {
    user?: {
      partnerData?: {
        activeProducts?: unknown
        partnerId?: string
      } | null
    }
  }
  userProfile?: {
    userProfile?: {
      idpUserId?: string
      roles?: unknown
      timeZone?: string
    }
  }
  [key: string]: unknown
}

export type LoggerContext = {
  globalState?: LoggerGlobalState
  additionalContext?: Record<string, unknown>
}

export const errorLogger =
  ({ globalState, additionalContext }: LoggerContext = {}) =>
  (error: Error, request_id?: string) => {
    const activeProducts =
      globalState?.AccountData?.user?.partnerData?.activeProducts
    const partnerId =
      globalState?.AccountData?.user?.partnerData?.partnerId ?? ''
    const oktaUserId = globalState?.userProfile?.userProfile?.idpUserId ?? ''
    const user = globalState?.userProfile?.userProfile

    const envVariables =
      (globalThis as { process?: { env?: Record<string, unknown> } }).process
        ?.env || 'no env variables available'

    const logContext = {
      partnerId:
        partnerId && partnerId !== 'null' && partnerId !== 'undefined'
          ? partnerId
          : 'no partner ID',
      oktaUserId:
        oktaUserId && oktaUserId !== 'null' && oktaUserId !== 'undefined'
          ? oktaUserId
          : 'no okta user id',
      envVariables,
      activeProducts: activeProducts || 'no active products',
      user_roles: user?.roles || 'no roles available',
      time_zone: user?.timeZone || 'no timezone available',
      request_id: request_id,
      ...additionalContext,
    }
    logError(error as Error, {
      ...logContext,
      error: error,
    })
  }
